(ns net.kestec.re-frame.subscription
  (:require [re-frame.core :as rf]))

(defn reg-slot-subs [& subs]
  (doseq [s subs]
    (rf/reg-sub s #(get % s))))

(defn reg-drv-sub [name sub]
  (rf/reg-sub name :<- sub (fn [v _] v)))

(defn get! [& subscription]
  @(rf/subscribe (vec subscription)))
